import React from 'react';
import FullPageSuccess from 'components/FullPageSuccess';
import { INVESTOR_REPORTING } from 'adminConstants/routes';
import { useGetInvestorsInReport } from 'hooks/data/investorReporting/useGetInvestorsInReport';
import useExportReportingSample from 'hooks/data/investorReporting/useExportReportingSample';
import { makeStyles } from 'tss-react/mui';
import { useParams } from 'react-router-dom';
import Button from 'components/Button';

const useStyles = makeStyles()(() => ({
  text: {
    fontSize: 15,
    textAlign: 'center',
    marginTop: '0.75rem',
    marginBottom: '0.4rem',
    fontStyle: 'italic',
  },
}));

const SuccessPage: React.FC = () => {
  const { id: reportingId } = useParams<{ id: string }>();
  const { isLoading, data } = useGetInvestorsInReport({
    params: { reportingId, countOnly: true },
  });
  const { exportSample, isPending } = useExportReportingSample();
  const { classes } = useStyles();

  const downloadSample = () => {
    if (!isPending) {
      exportSample(reportingId);
    }
  };

  return !isLoading && data ? (
    <FullPageSuccess
      title="Your update has been successfully processed"
      additionalText={`This update has been created for ${data.investorsCount} investors. Your investors will now be able to view this update in their investor portals.`}
      proceedLink={INVESTOR_REPORTING}
      proceedText="View all submitted updates"
    >
      <>
        <p className={classes.text}>
          The system is currently creating individual PDF updates which will be
          available for download from the Investor Reporting table in 15-30
          minutes.
        </p>

        <Button onClick={downloadSample} variant="text" loading={isPending}>
          Download a sample update
        </Button>
      </>
    </FullPageSuccess>
  ) : null;
};

export default SuccessPage;
